import { useCallback } from "react";
import { createContainer } from "unstated-next";
import useSWR from "swr";
import { addEntityReview } from "../../../../../../../../../../../../API/Review";
// import { applySpec, pathOr } from "ramda";

const ReviewStore = createContainer((initialState) => {
  const { id: courseId, user, teacher, userType } = initialState;
  // TODO : Figure out how to apply schema to each review item
  // applySpec({
  //   id: pathOr("", ["entityId"]),
  //   info: pathOr("", ["entittyInfo"]),
  //   rating: pathOr("", ["rating"]),
  //   review: pathOr("", ["review"]),
  //   userId: pathOr("", ["userId"]),
  //   userProfilePic: pathOr("", ["userInfo", "profilePicture", "location"]),
  //   userName: pathOr("", ["name"]),
  // })

  const { data: reviews, error, mutate } = useSWR([
    `/review/v2/${teacher?.id}?status=APPROVED`,
    (data) => Array.isArray(data) ? data : []
  ]);

  const addReview = useCallback(
    async (teacherId, entityId, entityType, entitySubType, review, rating) => {
      const { success } = await addEntityReview(
        teacherId,
        entityId,
        entityType,
        entitySubType,
        review,
        rating
      );
      if (success) {
        await mutate();
      }
    },
    [mutate]
  );

  return {
    loading: !Boolean(reviews),
    loadFailed: Boolean(error),
    courseId,
    reviews,
    user,
    userType,
    teacher,
    addReview
  };
});

export default ReviewStore;
